import React from 'react'
import './MediaListElement.css';
import './WeekdaySchedulerEditor.css'
import '../App.css';
import path from 'path';
import moment from 'moment';
import {
    DeleteOutlined,
    EyeOutlined,
    PlusCircleFilled,
    CloseCircleFilled,
    PlayCircleOutlined,
    LinkOutlined,
    EditOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../actions';
import VideoThumbnail from 'react-video-thumbnail'; // use npm published version

import { Row, Col, Button, Tag, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const inputdateFormat = 'YYYY-MM-DD';
const dateFormat = 'DD/MM/YYYY';


class WidgetInstanceListElement extends React.Component {

    constructor(props) {
        super(props)

        this.state = { startDate: "", endDate: "" };
    }

    componentDidMount = () => {
        const { data = {} } = this.props
        const { StartDate = "", EndDate = "" } = data

        this.setState({ startDate: StartDate, endDate: EndDate })
    }

    addStartEndDate = () => {
        const { data = {} } = this.props
        const startDate = moment().format(inputdateFormat);
        const endDate = moment().format(inputdateFormat);

        this.setState({ startDate: startDate, endDate: endDate })
        // console.log(moment().format("YYYY-MM-DD"))
        // this.setState({ StartDate: "00:00:00", EndDate: "23:59:59" })
        this.updateMediaStartEndDate(data, startDate, endDate)
    }
    onStartEndDateChanged = (moments, value) => {
        const { data = {} } = this.props
        const startDate = moments[0].format(inputdateFormat);
        const endDate = moments[1].format(inputdateFormat);

        this.setState({ startDate: startDate, endDate: endDate })
        this.updateMediaStartEndDate(data, startDate, endDate)
    }

    updateMediaStartEndDate = (mediaData, startdate, enddate) => {

        const { requestServerPost, usertoken } = this.props
        const params = new FormData();

        // console.log("mediaData " + JSON.stringify(mediaData))

        params.append("fileid", mediaData.FileID)
        params.append("startdate", startdate)
        params.append("enddate", enddate)

        requestServerPost("update_file", params, {  }, (response) => {

        }, usertoken);
    }

    render() {
        const { data = {}, view = "large", onDeleteClick = () => { }, onPreviewClick = () => { }, onEditClick = () => { }, allowEdit = true, allowDelete = true } = this.props
        const { WidgetInstanceName = "", size = 0, WidgetCover = "", WidgetName = "" } = data

        var icon = WidgetCover;

        const startDate = this.state.startDate;
        const endDate = this.state.endDate;

        var description = WidgetName;


        var renderIcon = ((typeof icon) === "string") ? <img alt={icon} style={{ width: "45px" }} className="media-thumb-small" src={icon}></img> : <div className="center-content" style={{ width: "45px", margin: "5px", height: "35px", fontSize: "24px", textAlign: "center", display: "inline-block", objectFit: "cover" }}>{icon}</div>



        if (view !== "small")
            renderIcon = ((typeof icon) === "string") ? <img alt={icon} style={{ marginLeft: "20px", width: "80px", height: "80%", margin: "auto", objectFit: "contain" }} className="media-thumb" src={icon}></img> : <div className="center-content" style={{ width: "80px", margin: "4px", height: "80px", fontSize: "36px", textAlign: "center", display: "inline-block", objectFit: "cover" }}>{icon}</div>




        var content = null;
        switch (view) {
            case "small":

                content = (
                    <div className="media-list-element-small" >
                        <Row style={{ pointerEvents: "none", borderBottom: "1px solid #ddd" }}>
                            <Col className="center-content" style={{ pointerEvents: "none" }}>
                                {renderIcon}
                            </Col>
                            <Col style={{ pointerEvents: "none" }} className="media-list-element-small-col">
                                <Row justify="start" style={{ margin: "8px 0px auto 8px", height: "20px" }}>
                                    <div style={{ flex: 1 }} className="media-name"><div style={{ display: "inline-block", pointerEvents: "none" }}>{WidgetInstanceName}</div> </div>
                                </Row>
                                <Row justify="start" style={{ margin: "0px 0px auto 8px", height: "20px" }}>
                                    <div style={{ flex: 1, pointerEvents: "none" }} className="media-name">{description} </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>)
                break;
            default:
                content = (
                    <div className="media-list-element">
                        {renderIcon}
                        <div style={{ flex: 1, pointerEvents: "none" }} className="media-name center-content"><div style={{ flex: "inline-block" }}>{WidgetInstanceName}</div> </div>
                        <div style={{ flex: 0.5, pointerEvents: "none" }} className="media-name center-content">{WidgetName} </div>
                        <div style={{ flex: 1 }} className="center-content">
                            {(startDate == "" && endDate == "") ? <Button style={{ marginRight: "20px" }} onClick={this.addStartEndDate} type="text" icon={<PlusCircleFilled></PlusCircleFilled>}>Add Active Period</Button> : (
                                <Row justify="center" style={{ marginRight: "26px" }}>
                                    <Col className="center-content weekdayscheduler-dateinput">
                                        <RangePicker
                                            size="small"
                                            allowClear={false}
                                            bordered={false}
                                            suffixIcon={null}
                                            onChange={this.onStartEndDateChanged}
                                            separator="-"
                                            defaultValue={[moment(startDate, inputdateFormat), moment(endDate, inputdateFormat)]}
                                            format={dateFormat} />
                                    </Col>
                                    <Col>
                                        <div onClick={(e) => {
                                            this.setState({ startDate: "", endDate: "" });

                                            this.updateMediaStartEndDate(data, "", "")
                                            e.preventDefault();
                                        }} className="btn-remove-item" style={{ position: "absolute", right: "-26px", top: "8px" }}>
                                            <CloseCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </div>
                        {/* <div style={{ flex: 1, pointerEvents: "none" }} className="media-name center-content">{size} </div> */}
                        <div style={{ flex: 0.5 }} className="element-btn-container center-content">
                            {(allowEdit) ? <Button type="secondary" shape="circle" icon={<EditOutlined />} size="medium" onClick={onEditClick} /> : null}
                            <Button shape="circle" icon={<EyeOutlined />} size="medium" onClick={onPreviewClick} />
                            {allowDelete ? (<Button type="danger" shape="circle" icon={<DeleteOutlined />} size="medium" onClick={onDeleteClick} />) : null}
                        </div>
                    </div>
                )
                break;
        }
        return content
    }
}



const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(WidgetInstanceListElement);